exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newRamadan {\n  width: 7.5rem;\n  position: relative;\n  padding: 0.24rem 0.3rem;\n  font-family: SFPro, SFPro;\n  font-weight: 400;\n  font-size: 0.24rem;\n  color: #000000;\n  line-height: 0.36rem;\n  text-align: left;\n  font-style: normal;\n  box-sizing: border-box;\n}\n.newRamadan.arlang {\n  direction: rtl;\n}\n/* new root */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/activity/rulersRoot/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/activity/rulersRoot/index.less
// module chunks = 0